import { Form } from 'react-bootstrap';

interface ControlLabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}

export function ControlLabel({ children, className = 'mb-0', ...props }: ControlLabelProps) {
  return (
    <Form.Label
      style={{ fontSize: '0.875rem' }}
      className={`visually-hidden ${className}`}
      {...props}
    >
      <strong>
        {children} {props.required && <span className="text-danger">*</span>}
      </strong>
    </Form.Label>
  );
}
